export default "__VITE_ASSET__SQu1dgplSQobQDMbttD2Rg__"